import { render, staticRenderFns } from "./loadingTest.vue?vue&type=template&id=b8ab35c2&scoped=true"
import script from "./loadingTest.vue?vue&type=script&lang=js"
export * from "./loadingTest.vue?vue&type=script&lang=js"
import style0 from "./loadingTest.vue?vue&type=style&index=0&id=b8ab35c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab35c2",
  null
  
)

export default component.exports